// extracted by mini-css-extract-plugin
export default {"cPublicPage":"LayoutAuthenticate_cPublicPage__95B1n"};